export default __webpack_public_path__ + "static/IBMPlexSans-BoldItalic-Latin1-cb6433fba14ab72f4167fe19d5eeec70.woff2";